import moment from 'moment-timezone';

export const getLocalTime = (timezone = 'Australia/Melbourne', time) => {
	if (!time) {
		return moment.utc().tz(timezone);
	}

	return moment.utc(time).tz(timezone);
};

export const getUTCTimeFromLocal = (timezone, time) => {
	if (!time) {
		return moment.utc();
	}

	return moment(time).tz(timezone, true).utc();
};

export const getUTCTimeFromTenant = tenant => {
	const currentTimeLocal = getLocalTime(tenant.timezone);
	const UTCtime = currentTimeLocal.utc();
	return UTCtime;
};

export const getTenantGMTOffset = tenant => getLocalTime(tenant.timezone).utcOffset() / 60;

export const printSecondsNicely = (seconds, shouldRoundToMinutes) => {
	const minutes = Math.round(seconds / 60);

	if (minutes > 60) {
		return `${Math.floor(minutes / 60)} h ${minutes % 60} min`;
	}
	if (shouldRoundToMinutes) {
		return `${Math.floor(seconds / 60)} m ${seconds % 60} s`;
	}

	return `${minutes} min`;
};

export const printMillisecondsNicely = (milliseconds, short) => {
	// Get hours from milliseconds
	const hours = milliseconds / (1000 * 60 * 60);
	const absoluteHours = Math.floor(hours);

	// Get remainder from hours and convert to minutes
	const minutes = (hours - absoluteHours) * 60;
	const absoluteMinutes = Math.floor(minutes);

	// Get remainder from minutes and convert to seconds
	const seconds = (minutes - absoluteMinutes) * 60;
	const absoluteSeconds = Math.floor(seconds);

	if (short) {
		const h = absoluteHours > 9 ? absoluteHours : `0${absoluteHours}`;
		const m = absoluteMinutes > 9 ? absoluteMinutes : `0${absoluteMinutes}`;
		const s = absoluteSeconds > 9 ? absoluteSeconds : `0${absoluteSeconds}`;

		return `${h}:${m}:${s}`;
	}
	else {
		let valueToReturn = '';

		if (absoluteHours) {
			valueToReturn = `${valueToReturn} ${absoluteHours} h`;
		}
		if (absoluteMinutes) {
			valueToReturn = `${valueToReturn} ${absoluteMinutes} min`;
		}
		// Ensure seconds are appended even when there are no full minutes.
		if (absoluteSeconds) {
			valueToReturn = `${valueToReturn} ${absoluteSeconds} s`;
		}

		return valueToReturn.trim();
	}
};
